module.exports = __webpack_public_path__ + "media/images/services/harvesting-ca913b3be91037f312a7a5c1a8885234.jpg";